import React from "react";
import { UserRoleClaim } from "supertokens-auth-react/recipe/userroles";
import Session from "supertokens-auth-react/recipe/session";
import { connect, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { canAccessLink } from "../config/role.config";

const AuthorizedRoute = (props) => {
	const { activeRole } = props;
    const location = useLocation();
	const dispatch = useDispatch();
	const claimValue = Session.useClaimValue(UserRoleClaim);

	let userRole = activeRole || "";

	if (!userRole) {
		if (claimValue.loading || !claimValue.doesSessionExist) {
			return null;
		}
		let roles = claimValue.value;
		if (roles.length) {
			userRole = roles[0];
			dispatch({ type: "SET_ACTIVE_ROLE", data: userRole });
		}
	}
    
	const hasPermissionForLink = canAccessLink(userRole, location.pathname);
	if (!hasPermissionForLink) {
		return <Navigate to={"/404"} />;
	}

	return <>{props.children}</>;
};

const mapStateToProps = (state) => {
	const { landing } = state;
	return { ...landing };
};

export default connect(mapStateToProps, {})(AuthorizedRoute);
